import classNames from "classnames";

import type {ISearchComboboxSubOptionProps} from "../types/ISearchComboboxSubOptionProps";

import * as styles from "./SearchComboboxSubOption.module.css";

/** Building-number row (34px); the active state is the background only, a disabled number is muted. */
export const SearchComboboxSubOption = (props: ISearchComboboxSubOptionProps) => {
    const {title, meta, isActive, isDisabled, className, dataTestId, ...optionProps} = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;
    const isDisabledResolved = isDisabled ?? optionProps["aria-disabled"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            className={classNames(styles.subOption, isActiveResolved && styles.subOptionActive, isDisabledResolved && styles.subOptionDisabled, className)}
            data-testid={dataTestId}
        >
            <span className={styles.title}>{title}</span>
            {meta ? <span className={styles.meta}>{meta}</span> : null}
        </div>
    );
};
import classNames from "classnames";

import type {ISearchComboboxSubOptionProps} from "../types/ISearchComboboxSubOptionProps";

import * as styles from "./SearchComboboxSubOption.module.css";

/** Building-number row (34px); the active state is the background only, a disabled number is muted. */
export const SearchComboboxSubOption = (props: ISearchComboboxSubOptionProps) => {
    const {title, meta, isActive, isDisabled, className, dataTestId, ...optionProps} = props;
    const isActiveResolved = isActive ?? optionProps["aria-selected"] === true;
    const isDisabledResolved = isDisabled ?? optionProps["aria-disabled"] === true;

    return (
        <div
            role="option"
            aria-selected={false}
            {...optionProps}
            className={classNames(styles.subOption, isActiveResolved && styles.subOptionActive, isDisabledResolved && styles.subOptionDisabled, className)}
            data-testid={dataTestId}
        >
            <span className={styles.title}>{title}</span>
            {meta ? <span className={styles.meta}>{meta}</span> : null}
        </div>
    );
};
